import { useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { useAppStore, useSelectedProductionLine } from '@stores/appStore';
import { apiClient } from '@lib/api';
import { cn } from '@lib/utils';

export function ProductionLineSelector() {
  const selectedLine = useSelectedProductionLine();
  const {
    availableProductionLines,
    setAvailableProductionLines,
    setSelectedProductionLine,
  } = useAppStore();

  // Fetch available production lines
  useEffect(() => {
    async function fetchProductionLines() {
      try {
        const response = await apiClient.get('/production-lines');
        const lines = response.data.map((line: { name: string; label: string; lineType: string; timeZone: string }) => ({
          id: line.name,
          label: line.label,
          lineType: line.lineType as 'beverages' | 'pc' | 'tc',
          timeZone: line.timeZone,
        }));
        setAvailableProductionLines(lines);

        // Auto-select first beverages line if none selected
        if (!selectedLine && lines.length > 0) {
          const beveragesLine = lines.find((l: { lineType: string }) => l.lineType === 'beverages');
          setSelectedProductionLine(beveragesLine || lines[0]);
        }
      } catch (error) {
        console.error('Failed to fetch production lines:', error);
      }
    }

    fetchProductionLines();
  }, [setAvailableProductionLines, setSelectedProductionLine, selectedLine]);

  const beveragesLines = availableProductionLines.filter((l) => l.lineType === 'beverages');

  if (beveragesLines.length === 0) {
    return null;
  }

  return (
    <div className="relative">
      <select
        value={selectedLine?.id || ''}
        onChange={(e) => {
          const line = availableProductionLines.find((l) => l.id === e.target.value);
          if (line) {
            setSelectedProductionLine(line);
          }
        }}
        className={cn(
          'h-9 rounded-md border border-input bg-background px-3 pr-8 text-sm',
          'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
          'appearance-none cursor-pointer'
        )}
      >
        {beveragesLines.map((line) => (
          <option key={line.id} value={line.id}>
            {line.label}
          </option>
        ))}
      </select>
      <ChevronDown className="absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 opacity-50 pointer-events-none" />
    </div>
  );
}

export default ProductionLineSelector;
